/**
 * --- Accessibility Module ---
 * Accessibility functions for keyboard navigation.
 */

function accessibility() {
    // accessibility functions
    keypressListener();

    const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');

    headings.forEach((h) => {
        // Treat headings with only whitespace and/or non-breaking spaces as empty.
        const text = (h.textContent || '').replace(/\u00A0/g, ' ').trim();

        // If no meaningful text, and no meaningful non-text alternative, remove it.
        // (If you use aria-label/labelledby on headings for some reason, preserve them.)
        const hasAriaName =
            (h.getAttribute('aria-label') || '').trim().length > 0 ||
            (h.getAttribute('aria-labelledby') || '').trim().length > 0;

        if (!text && !hasAriaName) {
            h.remove();
        }
    });

    function keypressListener() {
        // keypress config
        var skiptoContentKey = 's',
            sendToHomepageKey = '1',
            sendToContactKey = '8',
            sendToAccessibilityKey = '0';
        // leave unless functionality requires changing
        var isMac = navigator.userAgent.indexOf('Mac OS X') != -1;
        var windowLocation = window.location;
        // which language
        var language;
        if (windowLocation.href.indexOf("en") > -1) {
            language = 'en';
        }
        if (windowLocation.href.indexOf("cym") > -1) {
            language = 'cym';
        }

        // change access key if Mac
        var accessKey = 'alt';
        if (isMac) {
            accessKey = 'meta';
        }

        //skip to content
        $(document).on('keydown', accessKey + '+' + skiptoContentKey, function (e) {
            //scroll to content position
            $('html,body').scrollTop($('#content').offset().top);
            return false;
        });
        //change page to homepage
        $(document).on('keydown', accessKey + '+' + sendToHomepageKey, function (e) {
            window.location = '/';
            return false;
        });
        //change page to homepage
        $(document).on('keydown', accessKey + '+' + sendToContactKey, function (e) {
            //change page to contact
            if (language == 'en') {
                window.location = '/contact/';
            }
            if (language == 'cym') {
                window.location = '/cysylltu/';
            }
            return false;
        });
        //change page to accessibility
        $(document).on('keydown', accessKey + '+' + sendToAccessibilityKey, function (e) {
            //change page to contact
            if (language == 'en') {
                window.location = '/accessibility/';
            }
            if (language == 'cym') {
                window.location = '/hygyrchedd/';
            }
            return false;
        });
    }

    document.querySelectorAll("table").forEach(table => {
        const rows = Array.from(table.rows);

        rows.forEach((row, rowIndex) => {
            const cells = Array.from(row.cells);

            cells.forEach((cell, cellIndex) => {
                if (cell.tagName !== "TH") return;
                if (cell.hasAttribute("scope")) return;

                const hasSpan = cell.hasAttribute("rowspan") || cell.hasAttribute("colspan");
                if (hasSpan) return;

                // Column headers (first row or thead)
                if (row.parentElement.tagName === "THEAD" || rowIndex === 0) {
                    cell.setAttribute("scope", "col");
                    return;
                }

                // Row headers (first column in tbody)
                if (cellIndex === 0 && row.parentElement.tagName === "TBODY") {
                    cell.setAttribute("scope", "row");
                }
            });
        });
    });
}